export const DEFAULT_STYLES = 'default';
export const REBRANDING_STYLES = 'rebranding';

export const getStyles = (isRebrandingEnabled: boolean) =>
    isRebrandingEnabled ? REBRANDING_STYLES : DEFAULT_STYLES;
